<section class="main cmargin" style="padding-bottom:0px">
    <div class="container privacy">
        <div class="row">
            <div class="col-md-12">
                <div class="title11">
                    <h1 style="margin-top:0px">Terms & Conditions</h1>
                    <p>
                        You hereby consent and agree that you have read and fully understood the Privacy Policy of
                        the Website.
                        The User further consents that the terms and contents of such Privacy Policy are acceptable
                        to him.
                    </p>
                </div>
                <div class="title">
                    <h1>Limited User</h1>
                    <p>
                        The User agrees and undertakes not to reverse engineer, modify, copy, distribute,
                        transmit, display, perform, reproduce, publish, license, create derivative works from,
                        transfer, or sell any information or software obtained from the Website. Limited
                        reproduction and copying of the content of the Website is permitted provided that Home
                        Fabrics (52.91.149.50) name is stated as the source and prior written permission
                        is sought. For the removal of doubt, it is clarified that unlimited or wholesale
                        reproduction, copying of the content for commercial or noncommercial purposes and
                        unwarranted modification of data and information within the content of the Website is not
                        permitted
                    </p>
                </div>
                <div class="title">
                    <h1>Intellectual Property</h1>
                    <p>Home Fabrics expressly reserve all intellectual property rights in all text, programs,
                        products, processes, technology, content and other materials, which appear on this Site.
                        Access to this Site does not confer and shall not be considered as conferring upon anyone
                        any license under any of Our or any third party's intellectual property rights. All rights,
                        including copyright, in this website are owned by or licensed to Home Fabrics. Any use of
                        this website or its contents, including copying or storing it or them in whole or part,
                        other than for your own personal, non-commercial use is prohibited without the permission of
                        Home Fabrics. You may not modify, distribute or re-post anything on this website for any
                        purpose.</p>

                    <p>
                        The Home Fabrics names and logos and all related product and service names, design marks and
                        slogans are the trademarks or service marks of Home Fabrics. No trademark or service mark
                        license is granted in connection with the materials contained on this Site. Access to this
                        Site does not authorize anyone to use any name, logo or mark in any manner. References on
                        this Site to any names, marks, products or services of third parties or hypertext links to
                        third party sites or information are provided solely as a convenience to you and do not in
                        any way constitute or imply our endorsement, sponsorship or recommendation of the third
                        party, information, product or service.
                    </p>

                    <p>
                        All materials, including images, text, illustrations, designs, icons, photographs, programs,
                        music clips or downloads, video clips and written and other materials that are part of this
                        Site (collectively, the "Contents") are intended solely for personal, non-commercial use.
                        You may download or copy the Contents and other downloadable materials displayed on the Site
                        for your personal use only. No right, title or interest in any downloaded materials or
                        software is transferred to you as a result of any such downloading or copying. You may not
                        reproduce (except as noted above), publish, transmit, distribute, display, modify, create
                        derivative works from, sell or participate in any sale of or exploit in any way, in whole or
                        in part, any of the Contents, the Site or any related software. All software used on this
                        Site is the property of Home Fabrics and protected by Indian and international copyright
                        laws. The Contents and software on this Site may be used only as a shopping resource. Any
                        other use, including the reproduction, modification, distribution, transmission,
                        republication, display, or performance, of the Contents on this Site is strictly prohibited.
                    </p>
                </div>
                <div class="title">
                    <h1>User Warranty & Representation</h1>
                    <p>
                        The User guarantees, warrants, and certifies that you are the owner of the content which you
                        submit or otherwise authorized to use the content and that the content does not infringe
                        upon the property rights, intellectual property rights or other rights of others.
                    </p>
                </div>

                <div class="title">
                    <h1>Indemnity</h1>
                    <p>
                        You agree to defend, indemnify and hold harmless Home Fabrics, its employees,partners,
                        officers, agents and their successors and assigns from and against any and all claims,
                        liabilities, damages, losses, costs and expenses, including attorney's fees, caused by or
                        arising out of claims based upon your actions or inactions, which may result in any loss or
                        liability to Us or any third party including but not limited to breach of any warranties,
                        representations or undertakings or in relation to the non-fulfillment of any of your
                        obligations under these Terms or arising out of the your violation of any applicable laws,
                        regulations including but not limited to Intellectual Property Rights, payment of statutory
                        dues and taxes, claim of libel, defamation, violation of rights of privacy or publicity,
                        loss of service by other subscribers and infringement of intellectual property or other
                        rights. This clause shall survive the expiry or termination of these Terms.
                    </p>
                </div>

                <div class="title">
                    <h1>Termination</h1>
                    <p>
                        o We may suspend or terminate your use of the Website or any service if we believe, in our
                        sole and absolute discretion that you have breached any of the Terms. We may also in our
                        sole discretion and at any time discontinue providing the service, or any part thereof.
                        Termination of your access to the use of the Website may be effected without prior notice to
                        you, and you acknowledge and agree that We may immediately bar any further access to the
                        Website
                    </p>
                    <p>
                        If you or We terminates your use of the Website or any service, We may delete any content or
                        other materials relating to your use of the Website and will have no liability to you or any
                        third party for doing so. You shall be liable to pay for any service or product that you
                        have already ordered till the time of Termination by either party whatsoever.
                    </p>
                </div>

                <div class="title">
                    <h1>Disclaimer of Warranties</h1>
                    <p>
                        This online privacy policy applies only to information collected through our website and not
                        to information collected offline.
                    </p>
                </div>

                <div class="title">
                    <h1>Terms and Conditions</h1>
                    <p><b>You expressly understand and agree that:</b></p>
                    <p>
                        Your accessing or use of the Website is at your sole risk. The Website is provided on an "as
                        is" and "as available" basis. We and our licensors, suppliers, vendors, parent, holding,
                        subsidiary and related companies, affiliates, officers, agents and employees expressly
                        disclaim all warranties of any kind, whether express or implied, including, but not limited
                        to the implied warranties of merchantability, fitness for a particular purpose and non-
                        infringement.
                    </p>
                    <p>
                        We, our associates and technology partners make no representations or warranties about the
                        accuracy, reliability, completeness, current-ness and/or timeliness of any content,
                        information, software, text, graphics, links or communications provided on or through the
                        use of the Site or that the operation of the Site will be error free and/or uninterrupted.
                        Consequently, we assume no liability whatsoever for any monetary or other damage suffered by
                        you on account of the delay, failure, interruption, or corruption of any data or other
                        information transmitted in connection with use of the Site; and/or any interruption or
                        errors in the operation of the Site.
                    </p>
                    <p>
                        We and our licensors, suppliers, vendors, parent, holding, subsidiary and related companies,
                        affiliates, officers, agents and employees make no warranty that:
                    </p>
                    <ul>
                        <li>The service will meet your requirements</li>
                        <li>The service will be uninterrupted, timely, secure, or error-free</li>
                        <li>The service will be accessible at any time or at all times via the channel selected or
                            used by you</li>
                        <li>The information, content or advertisements (collectively, the "materials") contained on,
                            distributed through, or linked, downloaded or accessed from or through the service, or
                            the results that may be obtained from the use of the service, will be accurate or
                            reliable.</li>
                        <li>This disclaimer does not apply to any product warranty offered by the manufacturer of
                            the product as specified in the product specifications. This disclaimer constitutes an
                            essential part of the Terms.</li>
                    </ul>
                </div>

                <div class="title">
                    <h1>Limitation of Liability</h1>
                    <p>
                        To the fullest extent permitted under applicable law, We, our associates, parent companies,
                        or suppliers shall not be liable for any indirect, incidental, special, incidental,
                        consequential or exemplary damages, including but not limited to, damages for loss of
                        profits, goodwill, use, data or other intangible losses arising out of or in connection with
                        the Site, its services or these Terms.
                    </p>
                    <p>
                        Without prejudice to the generality of the section above, our total liability to you for all
                        liabilities arising out of these Terms be it in tort or contract is limited to the value of
                        the product ordered by you.
                    </p>
                </div>

                <div class="title">
                    <h1>Website Security</h1>
                    <p>
                        You are prohibited from violating or attempting to violate the security of the Site,
                        including, without limitation
                    </p>

                    <ul>
                        <li>Accessing data not intended for you or logging onto a server or an account which you are
                            not authorized to access</li>
                        <li>Attempting to probe, scan or test the vulnerability of a system or network or to breach
                            security or authentication measures without proper authorization</li>
                        <li>Attempting to interfere with service to any other user, host or network, including,
                            without limitation, via means of submitting a virus to the Site, overloading,
                            "flooding," "spamming," "mail bombing" or "crashing;"</li>
                        <li>Sending unsolicited email, including promotions and/or advertising of products or
                            services</li>
                        <li>Forging any TCP/IP packet header or any part of the header information in any email or
                            newsgroup posting.</li>
                    </ul>
                    <p>
                        Violations of system or network security may result in civil or criminal liability. We will
                        investigate occurrences that may involve such violations and may involve, and cooperate
                        with, law enforcement authorities in prosecuting users who are involved in such violations.
                        You agree not to use any device, software or routine to interfere or attempt to interfere
                        with the proper working of this Site or any activity being conducted on this Site. You
                        agree, further, not to use or attempt to use any engine, software, tool, agent or other
                        device or mechanism (including without limitation browsers, spiders, robots, avatars or
                        intelligent agents to navigate or search this Site other than the search engine and search
                        agents available from USA & INDIA on this Site and other than generally available third
                        party web browsers (e.g., Netscape Navigator, Microsoft Internet Explorer, Google Chrome).
                    </p>
                </div>

                <div class="title">
                    <h1>Fraudulent /Declined Transactions</h1>
                    <p>
                        We reserve the right to recover the cost of goods, collection charges and lawyers fees from
                        persons using the Site fraudulently. We reserve the right to initiate legal proceedings against
                        such persons for fraudulent use of the Site and any other unlawful acts or acts or omissions in
                        breach of these terms and conditions.
                    </p>
                </div>

                <div class="title">
                    <h1>Entire Agreement</h1>
                    <p>
                        These Terms and Conditions of Use constitute the entire agreement between you and HOME Fabrics
                        and govern your use of the Website, superseding any prior understandings and agreements
                        between you and us and any previous statements or representations from either party to the
                        other party. These Terms do not apply to any affiliate services, third-party content or third-
                        party software that does not or cannot reasonably be deemed to form part of the Website which
                        may be provided to you by our licensors, suppliers, vendors, parent, holding, subsidiary or
                        related companies, other affiliates or other third parties, which may be subject to additional
                        terms and conditions imposed by that party. You also may be subject to additional terms and
                        conditions that may apply when you use affiliate services, third-party content or third-party
                        software.
                    </p>
                </div>

                <div class="title">
                    <h1>Non Transferability</h1>
                    <p>
                        You agree that your account on the Website is non-transferable. Any rights to your Account ID
                        or contents gets terminated and all contents therein permanently gets deleted. <b>Governing Law
                            and Jurisdiction</b>
                    </p>
                </div>

                <div class="title">
                    <h1>Contact Us</h1>
                    <p>
                        Please send any questions or comments (including all inquiries unrelated to copyright
                        infringement) regarding this website to <a
                            href="mailto:hf@homefabricsindia.com">hf@homefabricsindia.com</a>
                    </p>
                    <p><b>In India:</b></p>
                    <p>
                        #1346D, 27th cross, MCECHS Layout, <br>Dr.Shivaramkaranth Nagar, Jakkur, Bangalore-560077.
                        INDIA
                    </p>
                    <p><a href="mailto:hf@homefabricsindia.com">hf@homefabricsindia.com</a></p>
                    <p><b>Outside India:</b></p>
                    <p>
                        #201 N. brand Blvd, Suite 240, Glendale, CA-91203, USA
                    </p>
                    <p>Tel: <a href="tel:+12138408874">+1 213 8408874</a></p>
                    <p><a href="mailto:ravi@homefabricsindia.com">ravi@homefabricsindia.com</a></p>
                </div>
            </div>
        </div>
    </div>
</section>